import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgChartsModule } from 'ng2-charts';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import {
  PMChartType,
  TrialInsightsPaymentMilestoneChartService,
} from './payment-milestones-chart.service';
import { TrialInsightsPaymentMilestoneQueryService } from './payment-milestones-query.service';
import { TrialInsightsPaymentMilestoneStoreService } from './payment-milestones-store.service';
import { TrialInsightsPaymentMilestonesTableService } from './payment-milestones-table.service';
import { GenericTrialInsightsComponent } from '../../classes/trial-insights-component.class';
import { TrialInsightsHeaderComponent } from '../trial-insights-header/trial-insights-header.component';
import { TrialInsightsLegendComponent } from '../trial-insights-legend/trial-insights-legend.component';
import { TrialInsightsTableComponent } from '../trial-insights-table/trial-insights-table.component';

// REPLACE THIS

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsHeaderComponent,
    IconComponent,
    TooltipDirective,
    NgChartsModule,
    TrialInsightsLegendComponent,
    TrialInsightsTableComponent,
  ],
  selector: 'aux-trial-insights-finance-payment-milestones',
  styleUrls: [
    '../../trial-insights.component.scss',
    './trial-insights-finance-payment-milestones.component.scss',
  ],
  templateUrl: './trial-insights-finance-payment-milestones.component.html',
})
export class TrialInsightsFinancePaymentMilestonesComponent extends GenericTrialInsightsComponent<PMChartType> {
  storeService = inject(TrialInsightsPaymentMilestoneStoreService);

  cdr: ChangeDetectorRef;
  chartService: TrialInsightsPaymentMilestoneChartService;
  queryService: TrialInsightsPaymentMilestoneQueryService;
  tableService: TrialInsightsPaymentMilestonesTableService;

  constructor() {
    const chartService = inject(TrialInsightsPaymentMilestoneChartService);
    const tableService = inject(TrialInsightsPaymentMilestonesTableService);
    const queryService = inject(TrialInsightsPaymentMilestoneQueryService);
    const cdr = inject(ChangeDetectorRef);

    super({
      cdr,
      chartService,
      color: '#236262',
      queryService,
      tableService,
      title: 'Upcoming Payment Milestones (Total)',
    });

    this.chartService = chartService;
    this.tableService = tableService;
    this.queryService = queryService;
    this.cdr = cdr;
  }

  subscribeToData = () => {
    this.storeService.getPaymentMilestones$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    this.queryService
      .processPaymentMilestones$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  };
}
